import {client} from '../helpers/api';

export async function postAnnouncementSeen() {
  const body = {};

  const response = await client.post('/api/announcement-seen', body);

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}
